import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__wrapper content" }
const _hoisted_3 = { class: "header__controls" }

import { computed } from 'vue'
import { getAxiosErrorText } from '@/common/helpers'
import { api } from '@/network'

// Components
import Button from '@/components/ui/Button'
import Avatar from '@/components/ui/Avatar'
import { ElNotification } from 'element-plus'

// i18n
import { useI18n } from 'vue-i18n'
import { useCommonStore, useAuthModalStore } from '@/store'
import { useRouter, useRoute } from 'vue-router'
import useIsUserAuth from '@/hooks/useIsUserAuth'

// Computed

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const { t } = useI18n()

// Store
const commonStore = useCommonStore()
const modalStore = useAuthModalStore()

// Router
const router = useRouter()
const route = useRoute()

// Use
const isAuthUser = computed<boolean>(() => useIsUserAuth())
const buttonText = computed<string>(() => isAuthUser.value ? t('logout') : t('login'))
const buttonSvg = computed<string>(() => isAuthUser.value ? 'logout' : 'login')

// Methods
function openReg(): void {
  modalStore.openReg()
}

async function logOut(): Promise<void> {
  commonStore.loading = true

  try {
    localStorage.removeItem('token')
    api.http.setToken(null)
    commonStore.user = null
    if (route.name !== 'Main') {
      await router.push({ name: 'Main' })
    }
  } catch (e: any) {
    ElNotification({
      title: t('common.error'),
      message: getAxiosErrorText(e),
      type: 'error',
    })
  } finally {
    commonStore.loading = false
  }
}

function authClick(): void {
  if (isAuthUser.value) {
    logOut()
  } else {
    modalStore.openLogin()
  }
}


return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: {name: 'Main'} }, {
        default: _withCtx(() => [
          _createVNode(_component_draw_svg, {
            class: "header__logo",
            name: "logo"
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Button), {
          theme: "login",
          onClick: authClick
        }, {
          append: _withCtx(() => [
            _createVNode(_component_draw_svg, {
              name: buttonSvg.value,
              width: "15",
              height: "15"
            }, null, 8, ["name"])
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(buttonText.value) + " ", 1)
          ]),
          _: 1
        }),
        (!isAuthUser.value)
          ? (_openBlock(), _createBlock(_unref(Button), {
              key: 0,
              onClick: openReg
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('signin')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: {name: 'Profile'}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Avatar), {
                  picture: _unref(commonStore).user?.avatar
                }, null, 8, ["picture"])
              ]),
              _: 1
            }))
      ])
    ])
  ]))
}
}

})